import { Theme } from '@mui/material/styles';
import { PropsWithChildren, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/redux';

import { selectAuthState } from '@/redux/auth/selectors';
import { fetchFeatures, selectIsFeatureInitialized } from '@/redux/configs';
import { fetchTerritories } from '@/redux/countries';

import { FullPageLoaderOverlay } from '../Layout/FullPageLoader';

export function ConfigurationLoader({ children }: Readonly<PropsWithChildren>) {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(selectAuthState);
  const isConfigsInitialized = useAppSelector(selectIsFeatureInitialized);

  useEffect(() => {
    dispatch(fetchTerritories());
  }, [dispatch]);

  useEffect(() => {
    if (!isConfigsInitialized && user) {
      dispatch(fetchFeatures());
    }
  }, [dispatch, isConfigsInitialized, user]);

  if (!isConfigsInitialized && user) {
    return (
      <FullPageLoaderOverlay
        bgColor={(theme: Theme) => theme.palette.background.paper}
      />
    );
  }

  return <>{children}</>;
}
